import { ProjectTabs } from '@/app/pages/ProjectDetail/types';
import { RefObject, useEffect } from 'react';

export const useInitialScrollToTabs = (
  refElement: RefObject<HTMLDivElement | null>,
  onSetActiveTabId: (value: ProjectTabs) => void,
) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hash = window.location.hash;

      if (!hash) {
        return;
      }

      const hashSanitized = hash.replace('#', '');

      if (!hashSanitized) {
        return;
      }

      if (!Object.values(ProjectTabs).includes(hashSanitized as ProjectTabs)) {
        return;
      }

      onSetActiveTabId(hashSanitized as ProjectTabs);

      if (!refElement.current) {
        return;
      }

      refElement.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);
};
